module.exports = __webpack_public_path__ + "static/media/21_plantilla_rec_combo_duo_cp_gaseosas_pet_500_ccsa-01.82767778.png";